import { createSlice } from "@reduxjs/toolkit";
import { readGamificationBlob, restoreGamificationBlob } from "./gamificationService";

import { getStoredToken, isTokenExpired } from "./authTokenUtils";
import {
  ACCOUNT_DELETION_STORAGE_KEY,
  PERMANENTLY_DELETED_STORAGE_KEY,
} from "./accountDeletionStorage";

const token = getStoredToken();
const tokenValid = token && !isTokenExpired(token);

const initialState = {
  token: tokenValid ? token : null,
  isLoggedIn: !!tokenValid,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const payload = action.payload;
      const token =
        typeof payload === "string" ? payload : payload?.token ?? null;
      const storageTarget =
        typeof payload === "object" && payload?.storageTarget
          ? payload.storageTarget
          : "both";

      if (!token) return;

      state.token = token;
      state.isLoggedIn = true;

      if (storageTarget === "local" || storageTarget === "both") {
        localStorage.setItem("token", token);
      }
      if (storageTarget === "session" || storageTarget === "both") {
        sessionStorage.setItem("token", token);
      }
      if (storageTarget === "session") {
        localStorage.removeItem("token");
      }
    },
    logout: (state) => {
      state.token = null;
      state.isLoggedIn = false;
      const coinBlob = readGamificationBlob();
      const accountDeletionState = localStorage.getItem(ACCOUNT_DELETION_STORAGE_KEY);
      const permanentlyDeletedAccounts = localStorage.getItem(
        PERMANENTLY_DELETED_STORAGE_KEY
      );
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.removeItem("userData");
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("activeProfileContext");
      localStorage.clear();
      sessionStorage.clear();
      if (accountDeletionState) {
        localStorage.setItem(ACCOUNT_DELETION_STORAGE_KEY, accountDeletionState);
      }
      if (permanentlyDeletedAccounts) {
        localStorage.setItem(
          PERMANENTLY_DELETED_STORAGE_KEY,
          permanentlyDeletedAccounts
        );
      }
      restoreGamificationBlob(coinBlob);
      // Redirect will be handled in component using useNavigate
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
